function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDocumentFormRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14h8v-2h-8v2zM10 14h2v-2h-2v2zM14 19h8v-2h-8v2zM10 19h2v-2h-2v2zM14 24h8v-2h-8v2zM10 24h2v-2h-2v2zM21 10h6l-8-8v6a2 2 0 002 2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 28H7V4h10V2H7a2 2 0 00-2 2v24a2 2 0 002 2h18a2 2 0 002-2V12h-2v16z",
    fill: props.color
  }));
}

export default SvgIconDocumentFormRexOutline;